import { useCallback, useEffect, useRef, useState } from 'react';
import { toSringKVnd } from '~/utils/money';
import styles from './MoneyHeader.module.scss';
import clsx from 'clsx';
import Checkbox from '../checkbox/Checkbox';
import Select from '../select/Select';
import { optionsDay, optionsMonth, optionsType } from '~/constants/options';
import { findIndexByName, findNameByIndex } from '~/utils/options';
import { getCurrentDay, getCurrentMonth } from '~/utils/datetime';
import MenuModal from '../menu-modal/MenuModal';
import { useStore } from '~/store';

function MoneyHeader({ title, total, onCancel, onSave, currentFilter }) {
    const [state] = useStore();
    const { tripName, places } = state;
    const refPlace = useRef(null);
    const refType = useRef(null);
    const [showMenuModal, setShowMenuModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [filterDayMonth, setfilterDayMonth] = useState(
        !!currentFilter.filterDayMonth,
    );
    const [filterPlace, setfilterPlace] = useState(!!currentFilter.filterPlace);
    const [filterType, setfilterType] = useState(!!currentFilter.filterType);

    const [day, setDay] = useState(
        findIndexByName(
            optionsDay,
            currentFilter.filterDayMonth
                ? currentFilter.filterDayMonth.day
                : getCurrentDay(),
        ),
    );
    const [month, setMonth] = useState(
        findIndexByName(
            optionsMonth,
            currentFilter.filterDayMonth
                ? currentFilter.filterDayMonth.month
                : getCurrentMonth(),
        ),
    );

    const [type, setType] = useState(
        currentFilter.filterType
            ? findIndexByName(optionsType, currentFilter.filterType)
            : 0,
    );

    const [optionsPlace, setOptionsPlace] = useState([]);
    // const [, setPlaces] = useState([]);
    const [place, setPlace] = useState(0);

    const handleOnClickMenu = () => {
        setShowMenuModal((pre) => {
            if (!pre) setShowFilterModal(false);
            return !pre;
        });
    };

    const handleOnClickFilter = () => {
        setShowFilterModal((pre) => {
            if (!pre) setShowMenuModal(false);
            return !pre;
        });
    };

    const onChangeOptions = (index, name) => {
        switch (name) {
            case 'day':
                setDay(index);
                break;
            case 'month':
                setMonth(index);
                break;
            case 'type':
                setType(index);
                break;
            case 'place':
                setPlace(index);
                break;
            default:
                throw new Error('invalid name');
        }
    };

    const handleCancel = () => {
        setShowFilterModal(false);
        if (onCancel) onCancel();
    };

    const handleSave = () => {
        const dd = findNameByIndex(optionsDay, day);
        const MM = findNameByIndex(optionsMonth, month);
        const typeName = findNameByIndex(optionsType, type);
        const placeName = findNameByIndex(optionsPlace, place);
        const date = {
            day: dd,
            month: MM,
        };

        // console.log('day', dd);
        // console.log('month', MM);
        // console.log('type', typeName);
        // console.log('placeId', placeId);
        // console.log('date', date);

        // console.log('filterDayMonth', filterDayMonth);
        // console.log('filterType', filterType);
        // console.log('filterPlace', filterPlace);
        setShowFilterModal(false);
        if (onSave)
            onSave({
                filterDayMonth: filterDayMonth ? date : null,
                filterType: filterType ? typeName : null,
                filterPlace: filterPlace ? placeName : null,
            });
    };

    const getDayMonthString = () => {
        const dd = findNameByIndex(optionsDay, day);
        const MM = findNameByIndex(optionsMonth, month);
        const date = `${dd}/${MM}`;
        return date;
    };

    const handleRemoveFilterDayMonth = () => {
        setfilterDayMonth(false);
        if (onSave)
            onSave({
                ...currentFilter,
                filterDayMonth: null,
            });
    };

    const handleRemoveFilterPlace = () => {
        setfilterPlace(false);
        if (onSave)
            onSave({
                ...currentFilter,
                filterPlace: null,
            });
    };

    const handleRemoveFilterType = () => {
        setfilterType(false);
        if (onSave)
            onSave({
                ...currentFilter,
                filterType: null,
            });
    };

    const handleOnChangeFilterDayMonth = useCallback((newState) => {
        setfilterDayMonth(newState);
    }, []);

    const handleOnChangeFilterType = useCallback((newState) => {
        setfilterType(newState);
    }, []);

    const handleOnChangeFilterPlace = useCallback((newState) => {
        setfilterPlace(newState);
    }, []);

    useEffect(() => {
        setOptionsPlace(
            places.map((place) => ({
                name: place.name,
            })),
        );
    }, [places]);

    useEffect(() => {
        // console.log('refPlace.current', refPlace.current);
        // console.log('currentFilter.filterPlace', currentFilter.filterPlace);
        // console.log('optionsPlace', optionsPlace);
        if (
            refPlace.current &&
            currentFilter.filterPlace &&
            optionsPlace &&
            optionsPlace.length > 0
        ) {
            const index = findIndexByName(
                optionsPlace,
                currentFilter.filterPlace,
            );
            refPlace.current.changeSelectedIndex(index);
            setPlace(index);
        }
    }, [showFilterModal, optionsPlace, currentFilter.filterPlace]);

    return (
        <>
            <div className={styles.sticky}>
                <header className={styles.header}>
                    <div className={styles.menu} onClick={handleOnClickMenu}>
                        <i className="fa-solid fa-bars"></i>
                    </div>
                    <div className={styles.mainTitle}>{title}</div>

                    <button
                        className={styles.filterBtn}
                        onClick={handleOnClickFilter}
                    >
                        Lọc
                        <i className="fa-solid fa-filter-circle-dollar"></i>
                    </button>
                </header>

                <div className={styles.info}>
                    {showFilterModal ? (
                        <div className={styles.filtering}>
                            {(filterDayMonth || filterPlace || filterType) && (
                                <label className={styles.label}>
                                    <i className="fa-solid fa-filter-circle-dollar"></i>
                                </label>
                            )}
                            {filterDayMonth && (
                                <div className={styles.date}>
                                    {getDayMonthString()}
                                </div>
                            )}
                            {filterPlace && (
                                <div className={styles.place}>
                                    {findNameByIndex(optionsPlace, place)}
                                </div>
                            )}
                            {filterType && (
                                <div className={styles.type}>
                                    {findNameByIndex(optionsType, type)}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className={styles.filtering}>
                            {(currentFilter.filterDayMonth ||
                                currentFilter.filterType ||
                                currentFilter.filterPlace) && (
                                <label className={styles.label}>
                                    <i className="fa-solid fa-filter-circle-dollar"></i>
                                </label>
                            )}
                            {currentFilter.filterDayMonth && (
                                <div
                                    className={clsx(styles.common, styles.date)}
                                    onClick={handleRemoveFilterDayMonth}
                                >
                                    {currentFilter.filterDayMonth.day +
                                        '/' +
                                        currentFilter.filterDayMonth.month}
                                    <i className="fa-solid fa-xmark"></i>
                                </div>
                            )}
                            {currentFilter.filterPlace && (
                                <div
                                    className={clsx(
                                        styles.common,
                                        styles.place,
                                    )}
                                    onClick={handleRemoveFilterPlace}
                                >
                                    {currentFilter.filterPlace}
                                    <i className="fa-solid fa-xmark"></i>
                                </div>
                            )}
                            {currentFilter.filterType && (
                                <div
                                    className={clsx(styles.common, styles.type)}
                                    onClick={handleRemoveFilterType}
                                >
                                    {currentFilter.filterType}
                                    <i className="fa-solid fa-xmark"></i>
                                </div>
                            )}
                        </div>
                    )}

                    {!showFilterModal && (
                        <div className={styles.total}>{toSringKVnd(total)}</div>
                    )}
                </div>
                {tripName && (
                    <footer className={styles.footer}>
                        <i className="fa-solid fa-car-side"></i>
                        <span>{tripName}</span>
                        <i className="fa-solid fa-car-side"></i>
                    </footer>
                )}
            </div>
            {showMenuModal && (
                <div className={styles.menuModal}>
                    <MenuModal onClickOutside={() => setShowMenuModal(false)} />
                </div>
            )}
            {showFilterModal && (
                <div className={styles.filterModal}>
                    <div className={clsx(styles.filter, styles.filterDayMonth)}>
                        <Checkbox
                            title={'Lọc theo ngày tháng'}
                            onChange={handleOnChangeFilterDayMonth}
                            checked={!!currentFilter.filterDayMonth}
                        />
                        <div className={styles.date}>
                            <div className={styles.day}>
                                <Select
                                    options={optionsDay}
                                    intiSelectedIndex={day}
                                    onChange={onChangeOptions}
                                    name="day"
                                ></Select>
                            </div>
                            <div className={styles.separator}>/</div>
                            <div className={styles.month}>
                                <Select
                                    options={optionsMonth}
                                    intiSelectedIndex={month}
                                    onChange={onChangeOptions}
                                    name="month"
                                ></Select>
                            </div>
                        </div>
                    </div>

                    <div className={clsx(styles.filter, styles.filterPlace)}>
                        <Checkbox
                            title={'Lọc theo địa điểm'}
                            onChange={handleOnChangeFilterPlace}
                            checked={!!currentFilter.filterPlace}
                        />
                        <div className={styles.place}>
                            <Select
                                options={optionsPlace}
                                intiSelectedIndex={place}
                                onChange={onChangeOptions}
                                markdown
                                name="place"
                                ref={refPlace}
                            ></Select>
                        </div>
                    </div>

                    <div className={clsx(styles.filter, styles.filterType)}>
                        <Checkbox
                            title={'Lọc theo loại'}
                            onChange={handleOnChangeFilterType}
                            checked={!!currentFilter.filterType}
                        />
                        <div className={styles.type}>
                            <Select
                                options={optionsType}
                                intiSelectedIndex={type}
                                onChange={onChangeOptions}
                                markdown
                                name="type"
                                ref={refType}
                            ></Select>
                        </div>
                    </div>
                    <div className={styles.action}>
                        <button
                            className={styles.cancel}
                            onClick={handleCancel}
                        >
                            Hủy
                        </button>
                        <button className={styles.save} onClick={handleSave}>
                            Lưu
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}

export default MoneyHeader;
